EmojiProvider = require 'app/scripts/lib/emoji-provider'
React = require 'react'

module.exports = class EmojiProviderComponent extends React.Component
  @defaultProps:
    isSmallSpinner: false

  constructor: (props) ->
    super(props)
    @state =
      data: EmojiProvider.getDataSync()
      spinnerClass:
        if props.isSmallSpinner
          "spinner small"
        else
          "spinner loading"

  componentDidMount: ->
    @mounted = true
    if !@state.data
      EmojiProvider.getData().then (data) =>
        if @mounted
          @setState { data }

  componentWillUnmount: ->
    @mounted = false

  render: ->
    { children } = @props
    { data, spinnerClass } = @state

    if data?
      children data
    else
      React.createElement 'div', className: 'emoji-loading-spinner',
        React.createElement 'span', className: spinnerClass
